export default "__VITE_ASSET__BVna1x8i__"